import React, { useEffect, useCallback, useState, useContext } from "react";
import { debounce } from "lodash";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import APICall from "../../services/apiCall";
import AppContext from "../../context/Context";
import APIPortalTable from "../common/Table/APIPortalTable";

let materialColumns = [
  {
    accessorKey: "email_id",
    header: "Email",
    csvFormatter: (cell, row, rowIndex) => {
      if (cell === "") {
        return "--";
      } else {
        return cell;
      }
    },
    csvExport: true,
    sort: true,
  },
  {
    accessorKey: "master_customer_id",
    header: "Master Customer ID",
    csvFormatter: (cell, row, rowIndex) => {
      if (cell === "") {
        return "--";
      } else {
        return cell;
      }
    },
    csvExport: true,
    sort: true,
  },
  {
    accessorKey: "first_name",
    header: "First Name",
    csvFormatter: (cell, row, rowIndex) => {
      if (cell === "") {
        return "--";
      } else {
        return cell;
      }
    },
    csvExport: true,
    sort: true,
  },
  {
    accessorKey: "last_name",
    header: "Last Name",
    csvFormatter: (cell, row, rowIndex) => {
      if (cell === "") {
        return "--";
      } else {
        return cell;
      }
    },
    csvExport: true,
    sort: true,
  },
  {
    accessorKey: "city",
    header: "City",
    csvFormatter: (cell, row, rowIndex) => {
      if (cell === "") {
        return "--";
      } else {
        return cell;
      }
    },
    csvExport: true,
    sort: true,
  },
  {
    accessorKey: "state",
    header: "State",
    csvFormatter: (cell, row, rowIndex) => {
      if (cell === "") {
        return "--";
      } else {
        return cell;
      }
    },
    csvExport: true,
    sort: true,
  },
  {
    accessorKey: "zip",
    header: "Zip Code",
    csvFormatter: (cell, row, rowIndex) => {
      if (cell === "") {
        return "--";
      } else {
        return cell;
      }
    },
    csvExport: true,
    sort: true,
  },
];

const AddNewCustomerModal = ({
  noSearchCustomers,
  setNoSearchCustomers,
  applicationDetails,
  appid,
  devid,
  setAddCustomerParams,
}) => {
  const [searchCustomerValue, setSearchedCustomerValue] = useState("");
  const [searchedCustomers, setSearchedCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const { loginUserDetails } = useContext(AppContext);

  const findUsersAPICall = debounce((value) => {
    if (value?.length === 0) {
      setSearchedCustomers([]);
      return;
    }
    setLoading(true);
    let params = { search_value: value,devid:loginUserDetails.dev_id };
    APICall.servertrip("GET", "find_practice", loginUserDetails, params).then(
      (res) => {
        setSearchedCustomers(res?.data?.items);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
    );
  }, 1000);

  const debouncedFindUsers = useCallback(findUsersAPICall, []);
  const changeHandler = (event) => {
    const value = event?.target?.value;
    setSearchedCustomerValue(value);
    debouncedFindUsers(value);
  };

  useEffect(() => {
    if (Object.keys(rowSelection).length > 0) {
      let foundCustomer = searchedCustomers.find((cust) => cust.master_customer_id === Object.keys(rowSelection)[0]);

      setNoSearchCustomers(false);

      let params = {
        app_id: appid,
        master_customer_id: foundCustomer.master_customer_id,
        parent_master_customer_id: applicationDetails.parent_master_customer_id,
        user_name: foundCustomer.email_id, //Email id
        opt_flag: "1", //If ON then 1 else 0
        app_name: applicationDetails.app_name,
        dev_id: devid,
        partner_name: applicationDetails.partner_name,
        add_updated_by: loginUserDetails.user_name,
        old_flag: "1", // If ON then 1 else 0. here you need to pass 1
        is_add_updated_by_admin: loginUserDetails.is_partner === "0" ? "true" : "false",
      };

      setAddCustomerParams(params);
    }
  }, [rowSelection]);

  return (
    <div>
      <div className="mb-3">
        <Form.Group>
          <Form.Control
            required
            type="text"
            autoFocus={true}
            placeholder="Search using email, first name, last name, master id, If customer already exist"
            aria-label="Search"
            className="rounded-pill search-input"
            onChange={changeHandler}
            onInput={() => {
              setRowSelection({});
              setAddCustomerParams({});
            }}
          />
        </Form.Group>
        {noSearchCustomers && (
          <div className="d-flex justify-content-center" style={{ color: "#e63757" }}>
            Please choose a practice.
          </div>
        )}
        {/* <FontAwesomeIcon icon="search" className="position-absolute text-400 search-box-icon" /> */}
      </div>

      <APIPortalTable
        data={searchedCustomers}
        columns={materialColumns}
        loading={loading}
        enablePagination
        CSVFileName={"Customer List.csv"}
        enableRowSelection
        enableMultiRowSelection={false}
        onRowSelectionChange={setRowSelection}
        getRowId={(originalRow) => originalRow.master_customer_id}
        state={{ rowSelection }}
      />
    </div>
  );
};

export default AddNewCustomerModal;
